import { Component,  Input, Output, EventEmitter, OnInit } from '@angular/core';
import { nonSpecificPerformerName, Performer } from 'globals/store/performers.data';
import { ItemStatus, SessionItemInfo, ShareableItemTypes } from 'globals/store/share.data';
import { DropdownOption } from 'globals/store/programs.data';
import { singleSessionPerformersReselector } from 'src/app/store/reselectors/performers.reselector';
import { Wrapper } from '../wrapper.component';
import { ShareCodeComponent } from 'src/app/modules/share/share-code.component';
import { DropdownComponent } from '../misc/dropdown.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'performer-session-synopsis',
    template: `
<div class="dropdow_area">
  <div>Receive session information from: </div>
  <dropdown
    *ngIf="!!performerSelected"
    [ngClass]="{ noSelection: !performerSelected }"
    [selections]="performerOptions"
    [selected]="performerSelected"
    [null_text]="'Select'"
    (select)="changePerformerId.emit($event.id)"
  ><div class="header">Select</div></dropdown>
</div> 
<ng-container *ngIf="!!synopsisInfo">
  <div class="share-hint">
    YOUR SHAREABLE WEBFORM:
  </div>

  <share-code 
    [shareType]="shareType"
    [shareCode]="synopsisInfo?.id" 
    [hideTitle]="true"
    [disabled]="!['Active', 'Submitted'].includes(synopsisInfo?.status || '')"
    [hideJson]="true"
    [emailGenerator]="emailGenerator"
    [selectedStatus]="synopsisInfo?.status || null"
    (changeStatus)="changeStatus.emit($event)">
  </share-code>
</ng-container>

`,
    styles: [`
  .grey-hint { margin-top: 10px; }
  .header, ::ng-deep dropdown.noSelection .dropdown-label .name { color: rgba(0,0,0,0.4); font-style: italic; }
  .header { pointer-events: none; margin: 10px 15px 5px; }
  .share-hint { margin-bottom: 10px; }
  performer-card { display: block; margin-top: 10px; }
  .dropdow_area { display: flex; align-items: center; margin-bottom: 20px; }
  .dropdow_area dropdown { border: solid 1px #ddd; padding: 7px 5px 7px 13px; border-radius: 6px; margin-left: 10px; }
  dropdown { min-width: 150px; }
`],
    standalone: true,
    imports: [ShareCodeComponent, DropdownComponent, CommonModule],
})
export class PerformerSynopsisComponent extends Wrapper<PerformerSynopsisComponent> implements OnInit {

  @Input() synopsisInfo: SessionItemInfo
  @Output() changeStatus:EventEmitter<ItemStatus> = new EventEmitter();
  @Output() changePerformerId:EventEmitter<string> = new EventEmitter();
  shareType = ShareableItemTypes.synopsis
  performer: Performer;
  nonSpecificPerformerName = nonSpecificPerformerName
  performerSelected: DropdownOption
  performerOptions: DropdownOption[]
  @Input() emailGenerator: (code: string) => string

  ngOnInit() {
    const sessionId = this.synopsisInfo.sessionId
    // console.log({ sessionId, synopsisInfo: this.synopsisInfo })
    this.subCallback(this.store.select(singleSessionPerformersReselector, sessionId), sessionInfo => {
      // console.log({ sessionInfo })
      if (!sessionInfo) return
      this.performerOptions = sessionInfo.dropdownSelections
      this.performerSelected = sessionInfo.dropdownSelection
    })
  }

  toggle(toggled: boolean) {
    if (toggled) {
      this.changeStatus.emit('Active');
    } else {
      this.changeStatus.emit('Off');
    }
  }
  
}






